
module.exports = function getResource(label, vars = []) {
    let resources = {
        all: 'Tous '
    };
    return resources[label];
};
